import React, { HTMLAttributes } from "react";
import { animated, useInView, useTrail } from "react-spring";

const STEPS = [
  {
    icons: "https://dqyerp2t68wdu.cloudfront.net/step1.gif",
    chinese_text: "掃描二維碼",
    english_text: "Scan QR code",
  },
  {
    icons: "https://dqyerp2t68wdu.cloudfront.net/step2.gif",
    chinese_text: "把充電線向下拉",
    english_text: "Pull Down the Cable",
  },
  {
    icons: "https://dqyerp2t68wdu.cloudfront.net/step3.gif",
    chinese_text: "插入充電槍",
    english_text: "Plug and Charge",
  },
] as const;

interface IStepBlock {}

type TStepBlockProps = IStepBlock & HTMLAttributes<HTMLDivElement>;

const StepBlock: React.FC<TStepBlockProps> = (props) => {
  const [ref, inView] = useInView({
    rootMargin: "-20%",
    once: false,
  });

  const trailSprings = useTrail(STEPS.length, {
    from: { transform: "translateY(80px)", opacity: 0 },
    to: inView
      ? { transform: "translateY(0)", opacity: 1 }
      : { transform: "translateY(80px)", opacity: 0 },

    config: { tension: 50, friction: 20 },
    delay: Math.random() * 1000,
  });

  return (
    <div
      ref={ref}
      className="flex flex-col laptop:flex-row gap-6 justify-between items-stretch"
    >
      {trailSprings.map((trail, index) => {
        return (
          <animated.div
            style={trail}
            key={index}
            className="min-h-[132px] flex flex-row laptop:flex-col flex-1 items-center gap-2 laptop:gap-5 px-4 py-4 laptop:px-5 laptop:py-5 bg-mainDark rounded-3xl text-white"
          >
            <animated.img
              src={STEPS[index].icons}
              loading={"lazy"}
              decoding={"async"}
              alt="icon"
              className="
              w-[100px] h-[100px] laptop:w-[180px] laptop:h-[180px] rounded-2xl"
            />
            <div className="w-full flex flex-1 flex-col laptop:flex-row gap-3 laptop:gap-5 pl-5 laptop:p-0">
              <span className="flex text-2xl laptop:text-4xl font-extrabold">
                {index + 1}
              </span>
              <div className="h-full flex flex-col laptop:text-center gap-2 laptop:gap-3">
                <span className="flex flex-1 font-bold text-lg laptop:text-2xl">
                  {STEPS[index].chinese_text}
                </span>
                <span className="flex flex-1 text-sm laptop:text-xl">
                  {STEPS[index].english_text}
                </span>
              </div>
            </div>
          </animated.div>
        );
      })}
    </div>
  );
};

export default StepBlock;
